export default {
  title: 'AJINGA+ 下载与安装指南',
  content: '下载AJINGA+简历获取小部件（仅限Chrome浏览器），以简化您在前程无忧、猎聘网和智联招聘等热门中国招聘网站上的搜寻简历并获取的工作。AJNGA+使您只需单击几下即可自动导入候选人简历信息，而无需离开招聘网站。通过自动候选人协议同意通知，您还可以确保符合PIPL要求。从Chrome应用商店下载并安装AJINGA+（推荐），或直接从AJINGA下载安装文件，立即开始！',
  optionFirst: '选项一:',
  optionSecond: '选项二:',
  downloadHead: '从',
  chromeStore: 'Chrome应用商店',
  downloadTail: '下载',
  downloadFromPackage: '安装包下载',
  downloadForMac: '为Mac OS下载',
  downloadForWindows: '为Windows下载',
  or: '或'
}
